import { useRouteLoaderData } from 'react-router'

export function useRequestInfo() {
	const data = useRouteLoaderData('root')
	return data.requestInfo
}
